// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__262nN","icon":"SortAdornment_icon__M9uBq","up":"SortAdornment_up__BWfZS","down":"SortAdornment_down__16Pbh","active":"SortAdornment_active__1_eZC"};